export const formatWeight = (value) => value != null ? `${parseFloat(Number(value).toFixed(3))} lbs.` : '';
export const formatPercent = (decimals) => (value) => value != null ? (value * 100).toFixed(decimals) + '%' : '\u2014';
export const formatDecimal = (decimals) => (value) => value != null ? value.toFixed(decimals) : '';

// US 16953 AC7: the dwh view reports an unknown GWP basis as 0, so show an em-dash instead of that 0.
export const formatGwpBasis = (value, row) => row?.gwpBasisUnknown ? '—' : (value ?? '');

export const formatDate = (value) => {
    if (!value) return '';
    return new Date(value).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
};

// Builds a CSV from the same column definitions the grid renders (headerName,
// field, valueFormatter), so exported values always match the on-screen table.
export const exportRowsToCsv = (columns, rows, fileName) => {
    const escapeCell = (value) => {
        const s = value == null ? '' : String(value);
        return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };

    const header = columns.map(col => escapeCell(col.headerName)).join(',');
    const lines = rows.map(row =>
        columns.map(col => {
            const value = row[col.field];
            return escapeCell(col.valueFormatter ? col.valueFormatter(value, row) : value);
        }).join(',')
    );

    // Leading BOM: Excel on Windows decodes a downloaded CSV as CP1252 and would mangle the em-dash.
    const blob = new Blob(['\uFEFF' + [header, ...lines].join('\n')], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
};
